import { createClient } from '@supabase/supabase-js'

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined
const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined

export const isSupabaseConfigured = Boolean(url && key)

if (!isSupabaseConfigured) {
  console.error('[Supabase] Configuração ausente. Verifique client/.env (VITE_SUPABASE_URL e VITE_SUPABASE_PUBLISHABLE_KEY).')
}

export const supabase = createClient(
  url || 'http://127.0.0.1:54321',
  key || 'missing',
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
)
